<template>
    <div>
        <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:lg:grid-cols-4 tw:xl:grid-cols-5 tw:gap-3">
            <BaseMultiselect
                id="search_for"
                name="search_for"
                :options="searchForOptions"
                value-key="id"
                label-key="label"
                :value="local.search_for"
                :disabled="disabled"
                @input="val => local.search_for = val"
            />

            <BaseMultiselect
                name="categoria"
                label="Categoría"
                :options="categorias"
                value-key="id"
                label-key="name"
                :value="local.categoria"
                :disabled="disabled || categorias.length === 0"
                @input="val => local.categoria = val"
            />

            <BaseMultiselect
                name="metodo_pago"
                label="Método de pago"
                :options="metodosPagoOptions"
                value-key="id"
                label-key="label"
                :value="local.metodo_pago"
                :disabled="disabled"
                @input="val => local.metodo_pago = val"
            />

            <BaseMultiselect
                name="equipo"
                label="Equipo"
                :options="equipos"
                value-key="id"
                label-key="nombre"
                :value="local.equipo"
                :disabled="disabled || equipos.length === 0"
                @input="val => local.equipo = val"
            />

            <div class="tw:flex tw:items-end tw:justify-end tw:sm:col-span-2 tw:lg:col-span-4 tw:xl:col-span-1">
                <Button
                    :disabled="disabled"
                    customClass="tw:w-full tw:sm:w-auto tw:justify-center"
                    @click="resetFilters"
                >
                    Limpiar filtros
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { reactive, watch } from 'vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        filters: {
            type: Object,
            required: true
        },
        categorias: {
            type: Array,
            default: () => []
        },
        equipos: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['reset', 'update:filters'])
    const local = reactive({ ...props.filters })

    const searchForOptions = [
        { id: '', label: 'BUSCAR POR' },
        { id: 'nombre', label: 'Nombre' },
        { id: 'apellidos', label: 'Apellidos' },
        { id: 'dni', label: 'DNI' },
        { id: 'email', label: 'Email' },
        { id: 'dni_responsable', label: 'DNI responsable' },
        { id: 'email_responsable', label: 'Email responsable' }
    ]

    const metodosPagoOptions = [
        { id: '', label: 'MÉTODO DE PAGO' },
        { id: '1', label: 'Metálico' },
        { id: '3', label: 'Tarjeta' },
        { id: '4', label: 'Transferencia' },
        { id: '7', label: 'Domiciliación' }
    ]

    watch(
        () => props.filters,
        newVal => {
            if (!newVal) return
            Object.assign(local, newVal)
        },
        { deep: true }
    )

    watch(
        local,
        val => {
            emit('update:filters', { ...val })
        },
        { deep: true }
    )

    function resetFilters() {
        emit('reset')
    }
</script>
